<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[520px] max-w-[90%] max-h-[90%]' }">
  <vs-dialog-header
    class="self-start w-full"
    [config]="{
      mode: 'simple',
      icon: mode === 'authorize' ? 'check-verified-02' : 'reverse-left',
      iconTheme: mode === 'authorize' ? 'primary' : 'warn',
      title: mode === 'authorize' ? 'Authorize Claim' : 'Reverse Authorization',
      subtitle:
        mode === 'authorize'
          ? 'This records the financial decision and locks the jobs it covers.'
          : 'This keeps the original record, adds a reversal, and unlocks the jobs it covered.',
      showDivider: true
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="flex flex-col gap-4 w-full mt-4" (keydown.enter)="$event.preventDefault()">
    <dl *ngIf="totals as claimTotals" class="flex flex-col gap-1 text-sm border rounded-xl px-4 py-3">
      <div class="flex justify-between">
        <dt class="text-gray-500">Authorized gross</dt>
        <dd>{{ formatAmount(claimTotals.authorizedGross, claimTotals.currency) }}</dd>
      </div>
      <div *ngIf="claimTotals.tax" class="flex justify-between text-xs text-gray-500">
        <dt class="pl-3">incl. tax</dt>
        <dd>{{ formatAmount(claimTotals.tax, claimTotals.currency) }}</dd>
      </div>
      <div class="flex justify-between">
        <dt class="text-gray-500">Deductible</dt>
        <dd>-{{ formatAmount(claimTotals.deductible, claimTotals.currency) }}</dd>
      </div>
      <div class="flex justify-between border-t pt-1 mt-1 font-semibold text-gray-900">
        <dt>Net payable</dt>
        <dd>{{ formatAmount(claimTotals.netPayable, claimTotals.currency) }}</dd>
      </div>
    </dl>

    <div *ngIf="mode === 'authorize'" class="flex flex-col gap-2">
      <p class="text-sm font-medium text-gray-700">Pay to</p>

      <label
        class="flex items-center gap-2 border rounded-xl px-3 py-2 cursor-pointer"
        [class.border-primary-500]="form.controls.payeeType.value === payeeTypes.CUSTOMER"
      >
        <input
          vsInput
          type="radio"
          class="!rounded-full"
          name="payeeType"
          [value]="payeeTypes.CUSTOMER"
          formControlName="payeeType"
        />
        <span class="text-sm text-gray-900">
          Customer <span *ngIf="customerName" class="text-gray-500">· {{ customerName }}</span>
        </span>
      </label>

      <label
        class="flex items-center gap-2 border rounded-xl px-3 py-2"
        [class.cursor-pointer]="!!shopName"
        [class.opacity-50]="!shopName"
        [class.border-primary-500]="form.controls.payeeType.value === payeeTypes.SERVICE_PROVIDER"
      >
        <input
          vsInput
          type="radio"
          class="!rounded-full"
          name="payeeType"
          [value]="payeeTypes.SERVICE_PROVIDER"
          formControlName="payeeType"
          [attr.disabled]="shopName ? null : true"
        />
        <span class="text-sm text-gray-900">
          Repair shop
          <span class="text-gray-500">· {{ shopName ?? 'Assign a repair shop to pay the shop.' }}</span>
        </span>
      </label>
    </div>

    <label *ngIf="isZeroPay" class="flex items-start gap-2 cursor-pointer">
      <input vsInput type="checkbox" class="mt-0.5" formControlName="isZeroPayConfirmed" />
      <span class="text-sm text-gray-700">
        Nothing will be paid on this claim. I reviewed it and decided to authorize it for $0.
      </span>
    </label>

    <ws-claim-lock-notice *ngIf="lockNotice" [notice]="lockNotice"></ws-claim-lock-notice>

    <p *ngIf="mode === 'reverse' && authorization" class="text-sm text-gray-700">
      Reversing authorization <strong>{{ authorization.reference }}</strong>.
    </p>

    <vs-form-field
      appearance="responsive"
      [config]="{ label: mode === 'authorize' ? 'Reason (optional)' : 'Reason for the reversal' }"
    >
      <textarea
        vsInput
        minRows="2"
        maxRows="4"
        formControlName="reason"
        [placeholder]="mode === 'authorize' ? 'e.g. All repair items adjudicated' : 'e.g. Wrong labor rate applied'"
      ></textarea>
    </vs-form-field>

    <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
      <button
        vs-button
        type="button"
        appearance="outline"
        class="w-full sm:w-auto"
        [disabled]="saving"
        (click)="close()"
      >
        Cancel
      </button>

      <button
        vs-button
        type="button"
        [theme]="mode === 'authorize' ? 'primary' : 'warn'"
        class="w-full sm:w-auto"
        [disabled]="saving || !isValid"
        (click)="submit()"
      >
        {{ mode === 'authorize' ? 'Authorize' : 'Reverse' }}
      </button>
    </div>
  </form>
</vs-dialog>
